import { sortPackages } from '@retail/products/utils';
import { SupplierItemCalculationDTO } from '../../dto';
import { PackageType } from '@retail/products/types';
import { PackageCalculation } from './PackageCalculation';
import { PriceRoundingBrand } from '@retail/rounding/types';

export interface SupplierItemCalculationProps {
  mgSupplierItemId: number;
  primaryText: string;
  secondaryText: string;
  supplierNumber: number;
  supplierName: string;
  inAssortment: boolean;
  prioritised: boolean;
  basePriceUnit: string;
  primaryUnit: string;
  packageTypes: PackageType[];
  dates: Date[];
  packages: PackageCalculation[];
}

export class SupplierItemCalculation {
  mgSupplierItemId: number;
  primaryText: string;
  secondaryText: string;
  supplierNumber: number;
  supplierName: string;
  inAssortment: boolean;
  prioritised: boolean;
  basePriceUnit: string;
  primaryUnit: string;
  packageTypes: PackageType[];
  dates: Date[];
  packages: PackageCalculation[];

  constructor({
    mgSupplierItemId,
    primaryText,
    secondaryText,
    supplierName,
    supplierNumber,
    inAssortment,
    prioritised,
    basePriceUnit,
    primaryUnit,
    packageTypes,
    dates,
    packages,
  }: SupplierItemCalculationProps) {
    this.mgSupplierItemId = mgSupplierItemId;
    this.primaryText = primaryText;
    this.secondaryText = secondaryText;
    this.supplierName = supplierName;
    this.supplierNumber = supplierNumber;
    this.inAssortment = inAssortment;
    this.prioritised = prioritised;
    this.basePriceUnit = basePriceUnit;
    this.primaryUnit = primaryUnit;
    this.packageTypes = packageTypes;
    this.dates = dates;
    this.packages = packages;
  }

  getPackageTypes = () => this.packageTypes.sort(sortPackages);

  static fromDTO = (
    dto: SupplierItemCalculationDTO,
    selectedBrand: PriceRoundingBrand
  ): SupplierItemCalculation =>
    new SupplierItemCalculation({
      mgSupplierItemId: dto.mgSupplierItemId,
      primaryText: dto.primaryText,
      secondaryText: dto.secondaryText,
      supplierName: dto.supplierName,
      supplierNumber: dto.supplierNumber,
      inAssortment: dto.inAssortment,
      prioritised: dto.prioritised,
      basePriceUnit: dto.basePriceUnit,
      primaryUnit: dto.primaryUnit,
      packageTypes: dto.packageTypes,
      dates: dto.dates.map((date) => new Date(date)),
      packages: dto.packages.map((dto) => PackageCalculation.fromDTO(dto, selectedBrand)),
    });
}
